var map = {
	"./3-CN-old.png": "BGi9",
	"./3-CN.png": "sdBn",
	"./3-EN-old.png": "MLwB",
	"./3-EN.png": "wkcd",
	"./4-CN.png": "lZQr",
	"./4-EN.png": "foty",
	"./5-CN-old.png": "rtnt",
	"./5-CN.png": "MVgV",
	"./5-EN-old.png": "TaPP",
	"./5-EN.png": "rj5Z",
	"./8-CN.jpg": "R//W",
	"./8-EN.png": "Fgjx",
	"./banner-btn-EN.png": "cPBW",
	"./banner-btn.png": "pMxa",
	"./banner-title-en.png": "yoHX",
	"./banner-title-old.png": "qVWJ",
	"./banner-title-old2.png": "6NOg",
	"./banner-title.png": "5Apu",
	"./guide_0.jpg": "E4w8",
	"./guide_1.jpg": "cEmM",
	"./guide_2.jpg": "rvUP",
	"./info-top.png": "oH+g",
	"./info_1.png": "7Nkm",
	"./info_2.png": "okz3",
	"./info_3.png": "WVNt",
	"./selected-circle.png": "Nflr",
	"./selected.png": "PMry",
	"./un-select-circle.png": "co8L"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KPfu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/.*$
// module id = KPfu
// module chunks = 1